import { Caption1Stronger, Caption2 } from '@fluentui/react-components';
import Moment from 'react-moment';

import { ProtocolPatient } from '../../../../models/Entities/Protocols/ProtocolPatient';

interface Props {
  numberInProtocol: string;
  protocolPatients: ProtocolPatient[];
}

const ProtocolPatientReferrerComponent = ({
  numberInProtocol,
  protocolPatients
}: Props) => {
  const currentProtocolPatient = protocolPatients.find(
    (item: ProtocolPatient) => item.numberInProtocol === numberInProtocol
  );

  const description = currentProtocolPatient?.medicalPractitioner?.fullName || 'No informado';
  const randomizationDate = currentProtocolPatient?.randomizationDate;

  return (
    <div className='visitDetail__field'>
      <Caption2>Médico derivador</Caption2>
      <Caption1Stronger>{description}</Caption1Stronger>
      {randomizationDate && (
        <div className='visitDetail__field'>
          <Caption2>Fecha de randomización</Caption2>
          <Caption1Stronger><Moment date={randomizationDate} format='DD/MM/YYYY' /></Caption1Stronger>
        </div>
      )}
    </div>
  );
};

export default ProtocolPatientReferrerComponent;
